import { InputGroup } from "@blueprintjs/core";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { RuleNumberArray } from "../../../src/types/rule";
import GameRuleNumberFixedCard from "./fixedcard";
import { useGame } from "@/src/contexts/game";
import styles from './fixedcards.module.css';
import Game from "@/src/models/game";

type Props = {
    isDisabled?: boolean;
    isEditable: boolean;
    onChange: (any) => void;
    rule: RuleNumberArray;
    value: number[];
};

export default function GameRuleNumberFixedCards({
    isDisabled,
    isEditable,
    onChange,
    rule,
    value,
}: Props) {
    const { game } = useGame();

    const components = useMemo(
        () => {
            const componentsToReturn: React.ReactNode[] = [];
            const g = new Game(game);

            const nonWildMapCards = game.map.data.cards
                .filter((mapCard) => !mapCard.isWild);

            for (let i = 0; i < nonWildMapCards.length; ++i) {
                const mapCard = nonWildMapCards[i];

                componentsToReturn.push(
                    <GameRuleNumberFixedCard
                        key={mapCard.id}
                        isDisabled={isDisabled}
                        isEditable={isEditable}
                        onChange={onChange}
                        mapCard={mapCard}
                        rule={rule}
                        index={i}
                        value={value}
                    />
                );
            }

            const wildCard = game.map.data.cards.find((card) => card.isWild);

            componentsToReturn.push(
                <GameRuleNumberFixedCard
                    key={wildCard.id}
                    isDisabled={isDisabled}
                    isEditable={isEditable}
                    onChange={onChange}
                    mapCard={wildCard}
                    rule={rule}
                    index={nonWildMapCards.length}
                    value={value}
                />
            );

            return componentsToReturn;
        },
        [game, isDisabled, isEditable, onChange, rule, value],
    );

    if (isDisabled) {
        return (
            <div className='bp5-text-disabled' style={{ fontStyle: 'italic' }}>
                disabled
            </div>
        );
    }

    return <table>
        <tbody>
            {components}
        </tbody>
    </table>
}
